import React, { Component } from 'react';
import { Button, Card, CardBody, CardGroup, Col, Container,
  Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import {Redirect} from 'react-router';
import {connect} from "react-redux";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchLogin } from '../../../redux/actions/users/aActions-userLogin.jsx';
import * as EmailValidator from 'email-validator';
import logo from '../../../assets/img/logo.png'
import InputText from '../../CustomComponents/InputText'
import { MoonLoader } from 'react-spinners'

class Login extends Component {
  constructor (props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      email: '',
      password: '',
      login:false,
      showPassAdd: false,
    };
  }

  handleSubmit(e){
    const { inputUsername, inputPassword } = this.state
    this.props.fetchLogin(inputUsername, inputPassword)
  }

  toggleShowPass = (event, type) => {
    if (event.type === "mousedown" || event.type === "touchstart") {
        if(type === 'add'){
            this.setState({showPassAdd: true})
        }
    } else {
        if(type === 'add'){
            this.setState({showPassAdd: false})
    }
  }
  }

  render() {
    const { from } = this.props.location.state || '/login'
    const toastStyle = {
      zIndex: 5000,
    };
    const {authData} = this.props
    console.log(authData)
    const isAuthenticated = () => {
      if(this.props.isAuthenticated === true) {
          return (<Redirect to="/dashboard" />)
      }
      else {
          return null;
      }
    }
    const { inputUsername, inputPassword } = this.state

    return (
      <div className="app flex-row align-items-center"> {isAuthenticated()}
      <ToastContainer position="bottom-right" autoClose={7500} style={toastStyle}/>
        <Container>
          <Row style={{marginBottom: '100px', marginTop: '-100px'}}>
              <Col style={{textAlign: 'center'}}>
                <img style={{width: '300px'}} src={logo}></img>
              </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8">
            <Card className="p-4" style={{background: 'rgba(255, 255, 255, 0.15)', border: '1px solid #F2F2F2', backdropFilter: 'blur(10px)'}}>
            <CardBody>
              <Form>
                <FormGroup style={{marginBottom: '24px'}}>
                  <Label htmlFor="username" style={{color:'#FFFFFF'}}>Nama Pengguna</Label>
                  <InputText id="inputUsername" value={inputUsername} onChange={e => this.setState({inputUsername: e.target.value})} autoComplete="off" style={{background: 'rgba(0, 0, 0, 0.45)'}}/>
                </FormGroup>
                <FormGroup style={{marginBottom: '40px'}}>
                  <Label htmlFor="password" style={{color:'#FFFFFF'}}>Kata Sandi</Label>
                  <InputGroup>
                  <InputText id="inputPassword" type={this.state.showPassAdd?"text":"password"} placeholder="Masukan Kata Sandi..." value={inputPassword} onChange={e => this.setState({inputPassword: e.target.value})} autoComplete="off" style={{background: 'rgba(0, 0, 0, 0.45)'}} required autoComplete='off' readonly onfocus="this.removeAttribute('readonly');"/>
                <InputGroupAddon addonType="append">
                <InputGroupText style={{color:'#9F9F9F', background: 'rgba(0, 0, 0, 0.45)', border:'0px'}}>
                <i className="fa fa-eye" style={{cursor:'pointer'}} onMouseDown={e => this.toggleShowPass(e, 'add')} onMouseUp={e => this.toggleShowPass(e, 'add')} onTouchStart={e => this.toggleShowPass(e, 'add')} onTouchEnd={e => this.toggleShowPass(e, 'add')}></i>
                </InputGroupText>
                </InputGroupAddon>
                </InputGroup>
              </FormGroup>
                  <Row>
                    <Col xs="12" style={{textAlignLast: 'center'}}>
                      <Button style={{color: '#fff', fontWeight: 700, background: '#18A0FB', border: 0, width: '240px'}} onClick={this.handleSubmit} className="px-4" disabled={(this.props.inProgress || inputUsername == '' || inputPassword == '' || inputUsername == null || inputPassword == null)}>
                        {(this.props.inProgress)?<center><MoonLoader color={'#ffffff'} size={16} loading={this.props.inProgress}/></center>:<div>Masuk</div>}
                      </Button>
                    </Col>
                    {this.props.isAuthenticated && (
                      <Redirect to={from || '/dashboard'}/>
                    )}
                  </Row>
                </Form> 
              </CardBody>
            </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
      authData : state.authStore.authData,
      inProgress: state.authStore.inProgress,
      isAuthenticated: state.authStore.isAuthenticated
  }
}

export default connect(mapStateToProps, {fetchLogin}) (Login);


// WEBPACK FOOTER //
// ./src/views/Users/Login/Login.jsx